<!-- Escondido pelo style do próprio elemento (vale sem CSS nenhum). Não usar [hidden]: o all.scss força display: none em [hidden] *. -->
<section class="agj-fallback" style="display: none" aria-labelledby="agj-fallback-title">
  @if (company(); as item) {
    @if (item.logoUrl) {
      <!-- lazy: escondido, o navegador não baixa; no iOS 12 o atributo é ignorado e o logo carrega -->
      <img class="agj-fallback-logo" [src]="item.logoUrl" alt="" loading="lazy" />
    }
    <p class="agj-fallback-title" id="agj-fallback-title">{{ item.name }}</p>
    <p class="agj-fallback-text">Este navegador não consegue abrir a agenda online. Fale com o estabelecimento para marcar o seu horário:</p>
    @if (item.isPhoneWhatsapp) {
      <a class="agj-fallback-btn" [href]="whatsappHref()" rel="noreferrer">Chamar no WhatsApp</a>
    }
    @if (phoneHref()) {
      <a class="agj-fallback-btn -secondary" [href]="phoneHref()">Ligar</a>
    }
  } @else {
    <p class="agj-fallback-title" id="agj-fallback-title">AgendaJá!</p>
    <p class="agj-fallback-text">
      Este navegador não consegue abrir a agenda online. Atualize o sistema do aparelho ou abra o link em outro navegador.
    </p>
  }
</section>
